import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-separator',
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.scss'],
  standalone: false
})
export class SeparatorComponent implements OnInit {
  @Input() labelKey: string;

  constructor() { }

  ngOnInit(): void {
  }

}
